/* eslint-disable no-unused-vars */
import './style.scss';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay,
     EffectFade,
     // Cubeはうまく動かないので削除 EffectCube,
     EffectCoverflow,
     EffectFlip,
     EffectCards,
     EffectCreative,
} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const setSwiper = () => {

    const slider = document.querySelectorAll('.lpcb-swiper');
    const effectOptionsMap = {
        fade: {
          fadeEffect: {
            crossFade: true,
          },
        },
        coverflow: {
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          },
        },
        flip: {
          flipEffect: {
            slideShadows: true,
            limitRotation: true,
          },
        },
        cards: {
          cardsEffect: {
            perSlideOffset: 8,
            perSlideRotate: 2,
            rotate: true,
            slideShadows: true,
          },
        },
        creative: {
          creativeEffect: {
              prev: {
                translate: ['-20%', 0, -200],
                opacity: 0.6,
                scale: 0.8,
              },
              next: {
                translate: ['20%', 0, -200],
                opacity: 0.6,
                scale: 0.8,
              },
          },
        },
        cube: {
          cubeEffect: {
              shadow: true,
              slideShadows: true,
              shadowOffset: 20,
              shadowScale: 0.94,
          },
        },
    };
      
    slider.forEach((elem, index) => {
        const wrapper = elem.querySelector('.swiper-wrapper');
        const hasNavigation = wrapper.dataset.navigation && wrapper.dataset.navigation === 'true' ? true : false;
        const hasPagination = wrapper.dataset.pagination && wrapper.dataset.pagination === 'true' ? true : false;
        const autoPlay = wrapper.dataset.autoPlay && wrapper.dataset.autoPlay === 'true' ? true : false;
        const loop = wrapper.dataset.loop && wrapper.dataset.loop === 'true' ? true : false;
        const loopV2 = wrapper.dataset.loopv2 && wrapper.dataset.loopv2 === 'true' ? true : false;
        let speed = wrapper.dataset.speed ? wrapper.dataset.speed : '0.3';
        let delay = wrapper.dataset.delay ? wrapper.dataset.delay : '4';
        const slidePerView = Number(wrapper.dataset.num ? wrapper.dataset.num : '1');
        const slidePerViewTablet = Number(wrapper.dataset.numTablet ? wrapper.dataset.numTablet : '1');
        const slidePerViewSp = Number(wrapper.dataset.numSp ? wrapper.dataset.numSp : '1');
        const spaceBetween = Number(wrapper.dataset.space ? wrapper.dataset.space : '10');
        const spaceBetweenTablet = Number(wrapper.dataset.spaceTablet ? wrapper.dataset.spaceTablet : '10');
        const spaceBetweenSp = Number(wrapper.dataset.spaceSp ? wrapper.dataset.spaceSp : '10');

        // console.log(wrapper.dataset);
        // ボタンやページネーションを親から相対で取得
        const container = elem.parentElement; 
        const nextBtn = container.querySelector('.lpcb-swiper-button-next');
        const prevBtn = container.querySelector('.lpcb-swiper-button-prev');
        const pagination = container.querySelector('.lpcb-swiper-pagination');

        speed = Number(speed) * 1000;
        delay = Number(delay) * 1000;

        const className = 'lpcb-swiper-' + index;
        elem.classList.add(className);

        const classNameSelector = '.' + className;

        const setting = {
            modules: [Navigation, Pagination, Autoplay, EffectFade, EffectCoverflow, EffectFlip, EffectCards, EffectCreative,],
            breakpoints: {
                992: {},
                768: {},
            }
        }

        const effect = wrapper.dataset.effect || 'slide';
        setting.effect = effect;
        if (effectOptionsMap[effect]) {
            Object.assign(setting, effectOptionsMap[effect]);
        }

        if (loop) {
            setting.loop = loop;
        }
        // v2があればv2で上書きする
        let isNewVersion = true;
        if ('loopv2' in wrapper.dataset) {
            setting.loop = loopV2;
        // 無ければ、前バージョンがloopのtrue/falseに関係なくループしていたのでtrueを入れる
        } else {
            setting.loop = true;
            isNewVersion = false;
        }

        // 新バージョン対応
        if ( isNewVersion ) {
            // 複数スライダーがあった場合のボタンが正しく動くように
            if (hasNavigation) {
                setting.navigation = {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                }
            }
            if (hasPagination) {
                setting.pagination = {
                    el: pagination,
                    clickable: true,
                }
            }
        // 旧バージョン対応
        } else {
            if (hasNavigation) {
                setting.navigation = {
                    nextEl: '.lpcb-swiper-button-next',
                    prevEl: '.lpcb-swiper-button-prev',
                }
            }
            if (hasPagination) {
                setting.pagination = {
                    el: '.lpcb-swiper-pagination',
                    clickable: true,
                }
            }
        }

        if (autoPlay) {
            setting.autoplay = {
                delay: delay,
            }
        }

        if (speed) {
            setting.speed = speed;
        }

        // 新バージョン対応
        if ( isNewVersion ) {
            if (slidePerViewSp) {
                setting.slidesPerView = slidePerViewSp;
            }
            if (slidePerViewTablet) {
                setting.breakpoints[768].slidesPerView = slidePerViewTablet;
            }
            if (slidePerView) {
                setting.breakpoints[992].slidesPerView = slidePerView;
            }
        // 旧バージョン対応
        } else {
            if (slidePerViewSp) {
                setting.slidesPerView = slidePerViewSp;
                if (slidePerViewSp >= 2) {
                    setting.loop = false;
                }
            }
            if (slidePerViewTablet) {
                setting.breakpoints[768].slidesPerView = slidePerViewTablet;
                if (slidePerViewTablet >= 2) {
                    setting.breakpoints[768].loop = false;
                }
            }
            if (slidePerView) {
                setting.breakpoints[992].slidesPerView = slidePerView;
                if (slidePerView >= 2) {
                    setting.breakpoints[992].loop = false;
                }
            }
        }

        // 各スライドの間隔
        if (spaceBetweenSp || spaceBetweenSp === 0) {
            setting.spaceBetween = spaceBetweenSp;
        }

        if (spaceBetweenTablet || spaceBetweenTablet === 0) {
            setting.breakpoints[768].spaceBetween = spaceBetweenTablet;
        }

        if (spaceBetween || spaceBetween === 0) {
            setting.breakpoints[992].spaceBetween = spaceBetween;
        }

        // console.log(setting);
        let swiper;
        if ( isNewVersion ) {
            swiper = new Swiper(elem, setting);
        } else {
            swiper = new Swiper(classNameSelector, setting);
        }

        // loop: falseで自動スライドの場合、スライドを強制停止させる reachEnd イベントリスナーを追加
        swiper.on('reachEnd', () => {
            if ( isNewVersion && !swiper.params.loop && swiper.params.autoplay ) {
                swiper.autoplay.stop();
            }
        });

    })
}
window.onload = setSwiper();